import { connect } from "react-redux";
import StakeholderGroupsAlignment from "./StakeholderGroupsAlignment";


const mapStateToProps = (state) => ({
    fetchRankDeltaApi: state.BenchmarkFilteringReducer.fetchRankDeltaApi,


});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(StakeholderGroupsAlignment);
